export default {
    //如何创建部门
    create: () =>  import( /* webpackChunkName: "appCreate" */ '../../views/app/create.vue'),
    // 下载
    download: () =>  import( /* webpackChunkName: "appDownload" */ '../../views/app/download.vue'),
    // yunzu
    yunzu: () =>  import( /* webpackChunkName: "appYunzu" */ '../../views/app/yunzu.vue'),
    // 链信隐私政策
    userAgreement: () =>  import( /* webpackChunkName: "appUserAgreement" */ '../../views/app/userAgreement.vue'),
    // 如何创建群
    help_v2: () =>  import( /* webpackChunkName: "appHelp" */ '../../views/app/help_v2.vue'),
    // 如何获取Ukey
    file_ukey: () =>  import( /* webpackChunkName: "appFileUkey" */ '../../views/app/file_ukey.vue'),
    // 中信银行收费标准
    file_fee: () =>  import( /* webpackChunkName: "appFileFee" */ '../../views/app/file_fee.vue'),
    // 中信银行函证流程
    file_pop: () =>  import( /* webpackChunkName: "appFilePop" */ '../../views/app/file_pop.vue'),
    // 链信新闻详情
    article: () =>  import( /* webpackChunkName: "appArticle" */ '../../views/app/article.vue'),
    // 小程序新闻详情
    articleApplet: () =>  import( /* webpackChunkName: "appArticle" */ '../../views/app/articleApplet.vue'),
    // 链信下载跳转
    appdown: () =>  import( /* webpackChunkName: "appAppDown" */ '../../views/app/appdown.vue'),

    //云证移动专题-首页
    yunZhengMD: () => import( /* webpackChunkName: "yunZhengMD" */ '../../views/app/yunZhengMD.vue'),
    //云证移动-融资页
    yunZhengMDfinace: () => import( /* webpackChunkName: "yunZhengMDfinace" */ '../../views/app/yunZhengMDfinace.vue'),
    // 链信认证说明 2021-01-08
    certification_instructions: () =>  import( /* webpackChunkName: "certification_instructions" */ '../../views/app/certification_instructions.vue'),
    //链信云保理移动端页面
    Lxh5:() => import( /* webpackChunkName: "Lxh5" */ '../../views/Lx/LxH5.vue'), 
    //云链H5(用户中心人脸认证结果)
    Ylh5:() => import( /* webpackChunkName: "Yxh5" */ '../../views/user/YlH5.vue'), 

  //云租询价详情分享H5
  inquiryDetail: () => import( /* webpackChunkName: "inquiryDetail" */ '../../views/app/inquiryDetail.vue'),
  //云租询价详情分享下载页H5
  yzDownload: () => import( /* webpackChunkName: "yzDownload" */ '../../views/app/yzDownload.vue'),
  faceAuthResults: () => import( /* webpackChunkName: "faceAuthResults" */ '../../views/user/faceAuthResults.vue'),
  // 2023.07.21 add 新增公共组件 查询人脸识别状态 页面 供给各业务线使用
  faceAuthResultsCommon: () => import( /* webpackChunkName: "faceAuthResultsCommon" */ '../../views/user/faceAuthResultsCommon.vue'),
  // emd
  faceComparisonResults: () => import( /* webpackChunkName: "faceComparisonResults" */ '../../views/user/faceComparisonResults.vue'),

  //链信-投资方查看融资排行-融资排行页面
  financingDetail: () => import( /* webpackChunkName: "financingDetail" */ '../../views/app/financingDetail.vue'),
  //链信-投资方查看融资排行-搜索页面
  financingSearch: () => import( /* webpackChunkName: "financingSearch" */ '../../views/app/financingSearch.vue'),

  
  //区块链IM专题页
  blockchainSpecial: () => import( /* webpackChunkName: "blockchainSpecial" */ '../../views/app/blockchainSpecial.vue'),

  //链信扫个人名片分享
  personalInformation:() => import( /* webpackChunkName: "personalInformation" */ '../../views/Lx/personalInformation.vue'), 
  //链信扫群名片分享
  groupInformation:() => import( /* webpackChunkName: "groupInformation" */ '../../views/Lx/groupInformation.vue'), 

  //消息发送-公告通知
  sendMessageType:() => import( /* webpackChunkName: "sendMessageType" */ '../../views/Lx/sendMessageType.vue'), 

  //邀请企业好友
  inviteFriends:() => import( /* webpackChunkName: "inviteFriends" */ '../../views/app/inviteFriends.vue'), 

  //华夏银行二维码页面
  hxQrcode:() => import( /* webpackChunkName: "inviteFriends" */ '../../views/app/hx_qrcode.vue'), 


}